<script lang="ts">
	import { isFilled, type Content } from '@prismicio/client';
	import { PrismicImage, type SliceComponentProps } from '@prismicio/svelte';

	type Props = SliceComponentProps<Content.ImageSlice>;

	const { slice }: Props = $props();
</script>

{#if isFilled.image(slice.primary.image)}
	<section data-slice-type={slice.slice_type} data-slice-variation={slice.variation}>
		<div class="container">
			<div class="row">
				<div class="col-12 col-lg-{slice.primary.width ?? 12}">
					<PrismicImage
						field={slice.primary.image}
						class="img-fluid {slice.primary.rounded_corners == true ? 'rounded' : ''}"
						loading="lazy"
					/>
				</div>
			</div>
		</div>
	</section>
{/if}
